import {
  Box,
  Button,
  Container,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Table,
  Tbody,
  Td,
  Text,
  Textarea,
  Thead,
  Tr,
  useToast,
} from "@chakra-ui/react";
import { useFormik } from "formik";
import { useEffect, useRef, useState } from "react";
import { HiArrowNarrowLeft } from "react-icons/hi";
import { useNavigate, useParams } from "react-router-dom";
import {
  ICourseSession,
  ICourseTerm,
} from "../../../models/admin/courseTermSession.model";
import AdminHelpers from "../../../services/admin/admin.service";

export default function AdminNewAnnouncement() {
  const navigate = useNavigate();
  const toast = useToast();
  const [students, setStudents] = useState<any[]>();
  const [session, setSession] = useState<ICourseSession[]>([]);
  const [term, setTerms] = useState<ICourseTerm[]>([]);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [uploadFileSize, setUploadFileSize] = useState("");
  const [batchFile, setbatchFile] = useState<File | undefined>();
  const [filename, setFilename] = useState("");
  const [filetype, setFiletype] = useState<string | undefined>("");
  const params = useParams();
  const course_id = params.course_id;

  useEffect(() => {
    AdminHelpers.getSessions()
      .then((response) => {
        setSession(response.data);
      })
      .catch((err) => err);

    AdminHelpers.getTerms()
      .then((response) => {
        setTerms(response.data);
      })
      .catch((err) => err);

    const maingender = [
      {
        id: "1",
        title: "Bolaji Muili",
      },
      {
        id: "2",
        title: "Olushola",
      },
    ];
    setStudents(maingender);
  }, []);

  const formik = useFormik({
    validate: (values: any) => {
      const errors: any = {};
      if (!values.title) {
        errors.title = "Title is required";
      }
      if (!values.content) {
        errors.content = "Description is required";
      }
      if (!batchFile) {
        errors.attachment = "Image is required";
      }

      return errors;
    },
    initialValues: {
      title: "",
      content: "",
      excerpt: "",
      attachment: "",
    },
    onSubmit: async (values) => {
      const formData = new FormData();
      // Check and append the batchFile if it exists
      if (batchFile) {
        formData.append("attachment", batchFile);
      }

      // Append the rest of the values to the FormData
      formData.append("title", values.title);
      formData.append("content", values.content);
      formData.append("excerpt", values.excerpt);

      try {
        const basicResponse = await AdminHelpers.adminCreateAnnouncement(
          formData
        );
        if (basicResponse) {
          toast({
            title: "Announcement",
            description: "Announcement created",
            status: "success",
          });
          formik.resetForm();
          navigate(-1);
        }
      } catch (error) {
        toast({
          title: "Announcement",
          description: "Something went Wrong. Try again later",
          status: "error",
        });
      }
    },
  });

  function isImage(file: any) {
    // Get the file name
    const fileName = file.name.toLowerCase();

    // Supported image file extensions
    const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp"];

    // Check if the file name ends with any of the image extensions
    for (const ext of imageExtensions) {
      if (fileName.endsWith(ext)) {
        return true; // It's an image file
      }
    }

    // If the file type is not in the list of image extensions
    return false;
  }
  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.files;

    if (value) {
      const selectedFile = value[0];

      if (selectedFile && isImage(selectedFile)) {
        const fileName = e.target.files?.item(0)?.name as string;
        setFilename(fileName);
        const fileType = e.target.files?.item(0)?.type;
        setFiletype(fileType);
        const file = e.target.files?.item(0) as File;

        setbatchFile(file);
      } else {
        formik.errors.attachment = "Please upload an image";
        throw new Error("Please select an image file");
      }
    }
  };

  return (
    <Box minHeight="100vh" pb="30px" bg="#F9F8F8" width={"100%"}>
      <Container
        width={{ lg: "50%", md: "80%", sm: "95%", base: "95%" }}
        maxWidth={"84%"}
        px={0}
        pt="100px"
        right={0}
        bg="F9F8F8"
        mx="auto"
      >
        <Box
          mb="60px"
          display="flex"
          alignItems="center"
          border="1px solid #616161"
          px="5px"
          py="7px"
          width="100px"
          borderRadius="5px"
          cursor="pointer"
        >
          <HiArrowNarrowLeft color="#616161" fontSize="20px" />
          <Text
            fontSize="14px"
            color="#616161"
            pl="5px"
            onClick={() => navigate(-1)}
            fontWeight={700}
          >
            Go Back
          </Text>
        </Box>
        <Box
          bg="white"
          px="40px"
          py="30px"
          boxShadow="sm"
          rounded="lg"
          height="auto"
          mb="30px"
        >
          <Text fontWeight="700" fontSize="24px" color="#1E1E1E">
            New Announcement
          </Text>
          <Box mt={4}>
            <form onSubmit={formik.handleSubmit}>
              <FormControl
                mt={6}
                mb="10px"
                isInvalid={
                  formik.errors.title && formik.touched.title ? true : false
                }
              >
                <FormLabel
                  fontWeight="700"
                  color="brand.3"
                  mb="10px"
                  fontSize="14px"
                >
                  Title{" "}
                  {/* <Text as="span" color="red">
                    (*){" "}
                  </Text> */}
                </FormLabel>
                <Input
                  type="text"
                  id="title"
                  name="title"
                  placeholder="Enter your title"
                  onChange={formik.handleChange}
                  fontSize={13}
                  value={formik.values.title}
                  height={"4rem"}
                />
                <FormErrorMessage fontSize={12}>
                  {formik.errors.title}
                </FormErrorMessage>
              </FormControl>
              {/* <FormControl mt={6} isInvalid={(formik.errors.recipient && formik.touched.recipient) ? true : false}>
                                  <FormLabel fontWeight="normal" color="brand.3" mb='10px' fontSize={13}>Recipient</FormLabel>
                                  <Select variant="outline" bg="inputText.500" size="sm" fontSize={12} placeholder="All Student" value={formik.values.recipient} name="courseFormat" onChange={formik.handleChange} color="brand.subtitle" >
                                      {
                                          students?.map(each => <option key={each.id} value={each.format_id}> {each.title} </option>)
                                      }
                                  </Select>
                                  <FormErrorMessage fontSize={12} >{formik.errors.recipient}</FormErrorMessage>
                              </FormControl> */}
              {filename && (
                <Box>
                  <Table variant="unstyled">
                    <Thead fontWeight="semibold">
                      <Tr color="brand.subtitle" fontSize={14}>
                        <Td>Filename</Td>
                        <Td>Type</Td>

                        <Td>Size</Td>
                      </Tr>
                    </Thead>

                    <Tbody>
                      <Tr fontSize={13} color="brand.subtitle">
                        <Td maxW="20em">{filename}</Td>
                        <Td>Image</Td>
                        <Td>{uploadFileSize}</Td>
                      </Tr>
                    </Tbody>
                  </Table>
                </Box>
              )}
              <FormControl
                mr={10}
                mt={6}
                isInvalid={
                  formik.errors.attachment && formik.touched.attachment
                    ? true
                    : false
                }
              >
                {!filename && (
                  <FormLabel fontWeight="600" color="brand.3" fontSize={13}>
                    Upload Image
                  </FormLabel>
                )}
                {!filename && (
                  <Text fontWeight="400" color="#959595" fontSize="14px">
                    Upload an image of the description.
                  </Text>
                )}
                <input
                  accept="image/*"
                  type="file"
                  name="attachment"
                  ref={inputRef}
                  onChange={(e) => handleFileChange(e)}
                  style={{ display: "none" }}
                ></input>
                <Input
                  cursor="pointer"
                  placeholder="No file selected"
                  defaultValue={filename}
                  mt="10px"
                  borderColor="#eeeeee"
                  fontSize={14}
                  bg="#fafafa"
                  onClick={() => inputRef?.current?.click()}
                  border="2px dashed"
                  borderRadius={2}
                />

                <FormErrorMessage fontSize={12}>
                  {" "}
                  {formik.errors.attachment}{" "}
                </FormErrorMessage>
              </FormControl>

              <FormControl mt={6} mb="10px">
                <FormLabel
                  fontWeight="700"
                  color="brand.3"
                  mb="10px"
                  fontSize="14px"
                >
                  Excerpt{" "}
                  {/* <Text as="span" color="red">
                    (*){" "}
                  </Text> */}
                </FormLabel>
                <Input
                  type="text"
                  id="excerpt"
                  name="excerpt"
                  placeholder="Short summary of your announcement"
                  onChange={formik.handleChange}
                  fontSize={13}
                  value={formik.values.excerpt}
                  height={"4rem"}
                />
                {/* <FormErrorMessage fontSize={12}>
                  {formik.errors.title}
                </FormErrorMessage> */}
              </FormControl>

              <FormControl
                mt={6}
                id="content"
                isInvalid={
                  formik.errors.content && formik.touched.content ? true : false
                }
              >
                <FormLabel
                  fontWeight="700"
                  color="brand.3"
                  mb="10px"
                  fontSize="14px"
                >
                  Description
                </FormLabel>
                <Textarea
                  p={4}
                  bg="inputText.500"
                  fontSize={12}
                  size="sm"
                  height="150px"
                  placeholder="Write your announcement"
                  name="content"
                  onChange={formik.handleChange}
                  value={formik.values.content}
                />
                <FormErrorMessage fontSize={12}>
                  {formik.errors.content}
                </FormErrorMessage>
              </FormControl>
              {/* <HStack spacing='15px' mt={6}>
                                  <Checkbox pb='28px' colorScheme='red' defaultChecked>
                                  </Checkbox>
                                  <Box>
                                      <Text color='#353535' fontWeight='600' fontSize='16px' pb='4px'>Send a copy to student mail</Text>
                                      <Text color='#9E9E9E' fontSize='12px' width='350px'>A copy of this announcement will be sent to the email of all students participating in this course</Text>
                                  </Box>
                              </HStack> */}
              {/* <HStack spacing='15px' mt={6}>
                                  <Checkbox pb='28px' colorScheme='red'>
                                  </Checkbox>
                                  <Box>
                                      <Text color='#353535' fontWeight='600' fontSize='16px' pb='4px'>Schedule announcement</Text>
                                      <Text color='#9E9E9E' fontSize='12px' width='350px'>Schedule a future date you want this announcement sent to your students</Text>
                                  </Box>
                              </HStack> */}
              <Box width="70%">
                {/* <HStack mt='15px'>
                                  <FormControl >
                                      <FormLabel fontWeight="600" color="#616161" fontSize={13}>Send on</FormLabel>
                                      <InputGroup>
                                          <Input placeholder="Select Start Date" type="date" bg="inputText.500" name="startDate" value={formik.values.startDate} onChange={formik.handleChange} fontSize={12} />
                                          <InputRightElement pointerEvents="none" children={<VscCalendar fontSize={20} color="#7883A7" />} />
                                      </InputGroup>
                                  </FormControl>
                                  <FormControl >
                                    
                                      <InputGroup pt='27px'>
                                          <Input placeholder="Select time" type="time" bg="inputText.500" name="startDate" value={formik.values.startTime} onChange={formik.handleChange} fontSize={12} />
                                          <InputRightElement pointerEvents="none" children={<VscCalendar fontSize={20} color="#7883A7" />} />
                                      </InputGroup>
                                  </FormControl>
                              </HStack> */}
              </Box>
              <Flex mt={12} justifyContent="flex-end">
                <Button
                  borderRadius={2}
                  colorScheme="red"
                  type="submit"
                  isLoading={formik.isSubmitting}
                  onClick={() => {
                    formik.handleSubmit();
                  }}
                  size="sm"
                  px={7}
                  fontSize={14}
                >
                  {" "}
                  PUBLISH
                </Button>
              </Flex>
            </form>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
